import { render } from "./ModuleConfirmationProbation.vue?vue&type=template&id=6634b7c3&scoped=true"
import script from "./ModuleConfirmationProbation.vue?vue&type=script&lang=js"
export * from "./ModuleConfirmationProbation.vue?vue&type=script&lang=js"

import "./ModuleConfirmationProbation.vue?vue&type=style&index=0&id=6634b7c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6634b7c3"]])

export default __exports__